import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { MobileBar } from "@/components/site/MobileBar";
import { CookieConsent } from "@/components/site/CookieConsent";
import Home from "@/pages/Home";
import Plans from "@/pages/Plans";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import DeliveryAreas from "@/pages/DeliveryAreas";
import FAQs from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import Account from "@/pages/Account";
import AccountDemo from "@/pages/AccountDemo";
import ResetPassword from "@/pages/ResetPassword";
import Checkout from "@/pages/Checkout";
import CheckoutReturn from "@/pages/CheckoutReturn";
import Admin from "@/pages/Admin";
import Policy from "@/pages/Policy";
import NotFound from "@/pages/NotFound";
import AreaPage from "@/pages/AreaPage";
import Guides from "@/pages/Guides";
import Guide from "@/pages/Guide";
import { captureAttribution } from "@/lib/referral";
import "@/App.css";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    captureAttribution();
  }, []);
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const POLICY_SLUGS = ["privacy", "terms", "subscription-policy", "cookie-policy"];

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-[#FF6A00] focus:px-4 focus:py-2 focus:text-[#080808]">
        Skip to content
      </a>
      <Header />
      <main id="main" className="pb-20 lg:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/about" element={<About />} />
          <Route path="/delivery-areas" element={<DeliveryAreas />} />
          <Route path="/log-delivery/:slug" element={<AreaPage />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/:slug" element={<Guide />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/account" element={<Account />} />
          <Route path="/account/reset" element={<ResetPassword />} />
          <Route path="/account/demo" element={<AccountDemo />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/return" element={<CheckoutReturn />} />
          <Route path="/admin" element={<Admin />} />
          {POLICY_SLUGS.map((s) => <Route key={s} path={`/${s}`} element={<Policy slug={s} />} />)}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <MobileBar />
      <CookieConsent />
      <Toaster theme="dark" position="top-center" richColors />
    </BrowserRouter>
  );
}
